<button
  mat-icon-button
  [disabled]="disabled"
  disableRipple
  [attr.aria-label]="'toggle ' + node?.label"
  (click)="nodeToggle.emit()"
  type="button"
>
  <i class="vitamui-icon icon {{ expanded ? 'vitamui-icon-chevron-down' : 'vitamui-icon-chevron-right' }}"></i>
</button>

<mat-checkbox
  id="enable{{ node?.id }}"
  [(ngModel)]="node.checked"
  [(indeterminate)]="node.disabledChild"
  [disabled]="node.disabled"
  (ngModelChange)="labelClick.emit()"
  >{{ node?.label }}</mat-checkbox
>
<label for="enable{{ node?.id }}" class="node-label" (click)="labelClick.emit()"></label>
